import { useEffect, useState } from "react";
import { Col, Row } from "antd";
import InputComponent from "../../../components/InputComponent";
import TextareaComponent from "../../../components/TextareaComponent";
import { useBannerMobileContext } from "../../../context/BannerMobileContext/BannerMobileContext";
import { BannerMobileDetailProps, BannerBodyConstants, BannerUrlHelperText, BannerTitleConstants, BannerUrlConstants } from "./constants";

const BannerMobileDetail: React.FC<BannerMobileDetailProps> = ({ Culture, hasNavigation }) => {
	const { bannerMobileForm, bannerMobileDetail, setBannerMobileForm } = useBannerMobileContext();
	const detailLocalizable = bannerMobileDetail?.bannerMobileLocalizable.find(item => item.culture === Culture);
	const [editableLocalizable, setEditableLocalizable] = useState(detailLocalizable);

	useEffect(() => {
		setEditableLocalizable(detailLocalizable);
	}, [detailLocalizable]);

	const handleLocalizableChange = (field: string, value: string) => {
		setEditableLocalizable(prevState => {
			if (!prevState) {
				return prevState;
			}

			return {
				...prevState,
				[field]: value,
			};
		});

		const updatedLocalizable = [...bannerMobileForm.bannerMobileLocalizable];
		const index = updatedLocalizable.findIndex(item => item.culture === Culture);
		if (index !== -1) {
			updatedLocalizable[index] = {
				...updatedLocalizable[index],
				[field]: value,
			};
		}
		setBannerMobileForm(prevState => ({
			...prevState,
			bannerMobileLocalizable: updatedLocalizable
		}));
	};

	return (
		<>
			{editableLocalizable && (
				<div key={editableLocalizable.culture}>
					<Row gutter={20}>
						<Col span={20}>
							<InputComponent
								title={BannerTitleConstants[Culture].title}
								placeholder={BannerTitleConstants[Culture].placeholder}
								value={editableLocalizable.firstHeader}
								isRequired
								onChange={(e) => handleLocalizableChange("firstHeader", e.target.value)}
							/>
						</Col>
					</Row>
					<Row gutter={20}>
						<Col span={20}>
							<TextareaComponent
								title={BannerBodyConstants[Culture].body}
								placeholder={BannerBodyConstants[Culture].placeholder}
								resizable={false}
								value={editableLocalizable.header}
								isRequired
								onChange={(e) => handleLocalizableChange("header", e.target.value)}
								rows={8}
							/>
						</Col>
					</Row>
					{hasNavigation && (
						<Row gutter={20} style={{ marginTop: 10 }}>
							<Col span={20}>
								<InputComponent
									title={BannerUrlConstants[Culture].url}
									helperText={BannerUrlHelperText}
									placeholder={BannerUrlConstants[Culture].placeholder}
									value={editableLocalizable.url}
									onChange={(e) => handleLocalizableChange("url", e.target.value)}
								/>
							</Col>
						</Row>
					)}
				</div>
			)}
		</>
	);
};

export default BannerMobileDetail;
